import React from 'react';

/**
 *
 * Scroll Fade In component
 * @extends {React.Component}
 */
interface IProps {
  columns?: number;
  smallColumns?: number;
  items?:any;
  noPadding?:string;
  children?:any;
  alignment?:any;
}

class GridStructure extends React.Component<IProps>{

  constructor(props: IProps) {
    super(props);
  }
  public render(): JSX.Element {
    let smallColumns = this.props.smallColumns ? 12/this.props.smallColumns : 12;
    let columns = this.props.columns ? (12/this.props.columns) : 6;
    let alignmentClass = this.props.alignment == 'centered' ? 'justify-center' : '';
    console.log(columns)
    return (
      <div className={"row grid-padded grid-structure "+alignmentClass}>
        {this.props.children && this.props.children.map((data:any,index:number)=>{
          let paddingClass="grid-padding";
          if(index == 0 && columns == 1){
            paddingClass = "";
          }
          if(index == 0 && columns > 1){
            paddingClass = paddingClass+" no-left-padding";
          }
          if(index == 1 && columns == 2){
            paddingClass = paddingClass+" no-right-padding";
          }
          if(index == this.props.children.length-1 && columns > 2){
            paddingClass = paddingClass+" no-right-padding";
          }
          if(this.props.noPadding){
            paddingClass="";
          }
          return <div className={"small-"+smallColumns.toString()+" medium-"+columns.toString()+" "+paddingClass}>
            {data}
          </div>
        })}
      </div>
    );
 }
}

 export default GridStructure;
